export default __webpack_public_path__ + "static/media/Award_Statue_Nut.256.94946606.png";